import * as PropTypes from "prop-types"
import {
  textHeader,
  narrowText,
  solidLegacyHeaderContent,
  solidHeader,
  solidHeaderContent,
  withAside,
  withAsideContent,
  altitude,
  altitudeContent,
  altitudeCloser,
  altitudeCloserContent,
  purple,
} from "./hero.module.css"
import RichText from "@components/rich-text/renderer"

const Hero = ({ id, type, children }) => {
  switch (type) {
    case "legacy":
    default:
      return (
        <section className={`section section--page-section block__2-column page__hero page__hero--${id}`}>
          <div className="row">
            <div className="column">{children}</div>
          </div>
        </section>
      )
    case "json":
      return (
        <section className={`section section--page-section block__2-column page__hero page__hero--${id}`}>
          <div className="row">
            <div className="column">
              <RichText body={children} />
            </div>
          </div>
        </section>
      )

    case "text":
      return <header className={textHeader}>{children}</header>
    case "narrowText":
      return <header className={narrowText}>{children}</header>
    case "solidLegacy":
      return (
        <div className={purple}>
          <div className={solidLegacyHeaderContent}>{children}</div>
        </div>
      )
    case "solid":
      return (
        <div className={solidHeader}>
          <div className={solidHeaderContent}>{children}</div>
        </div>
      )
    case "withH1":
      return (
        <div className={solidHeader}>
          <div className={solidHeaderContent}>
            <h1>{children}</h1>
          </div>
        </div>
      )
    case "withAside":
      return (
        <div className={withAside}>
          <div className={withAsideContent}>{children}</div>
        </div>
      )
    case "altitude":
      return (
        <div className={altitude}>
          <div className={altitudeContent}>{children}</div>
        </div>
      )
    case "altitudeCloser":
      return (
        <div className={altitudeCloser}>
          <div className={altitudeCloserContent}>{children}</div>
        </div>
      )
  }
}

Hero.propTypes = {
  type: PropTypes.oneOf([
    "legacy",
    "text",
    "solid",
    "json",
    "solidLegacy",
    "withAside",
    "altitude",
    "altitudeCloser",
    "narrowText",
  ]),
}

Hero.defaultProps = {
  type: "legacy",
  id: "13",
}

export default Hero
